module.exports = __webpack_public_path__ + "img/cart.5267eeda.png";